import { jsx as e } from "react/jsx-runtime";

import { CELL_SPACING as o } from "../../constants/index.js";

import r from "../../hooks/useTableContext/index.js";

import { Column as s } from "react-aria-components";

import t from "../../../../utils/classNames/index.js";

const n = ({children: n, id: a, className: i, isRowHeader: l, ...c}) => {
    const {model: d, cellSpacing: m} = r();
    "production" === process.env.NODE_ENV || d || "boolean" == typeof l || console.error('"isRowHeader" must be supplied to all columns when not using "useTable"');
    const p = d?.rowId ? a === d.rowId : l;
    return e(s, {
        ...c,
        isRowHeader: p,
        className: t("z-1 border-collapse border-b border-neutral-300", o[m], i),
        children: n
    });
};

export { n as default };
//# sourceMappingURL=index.js.map
